export function DraftOrderMethylationReanalysisChip() {
  return (
    <span className='rerequisition-chip rerequisition-chip--reanalysis' aria-label='Methylation reflex draft'>
      Methylation Reflex
    </span>
  );
}
